import { render, staticRenderFns } from "./DetailCard55.vue?vue&type=template&id=59e65402&scoped=true&"
import script from "./DetailCard55.vue?vue&type=script&lang=js&"
export * from "./DetailCard55.vue?vue&type=script&lang=js&"
import style0 from "./DetailCard55.vue?vue&type=style&index=0&id=59e65402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e65402",
  null
  
)

export default component.exports